import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { Button } from 'react-toolbox/lib/button';
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import Modal from 'react-modal';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { regExForName, regExForEmail } from 'constants/Regularexpression'; // regular expressions to validate user input
import Sendgrid from 'components/SendGrid';
import styles from './FooterContact.scss';// to import local scss fle


const modalStyle = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

class FooterContact extends Component {
  static propTypes = {
    sendContactForm: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      firstName: '',
      lastName: '',
      email: '',
      message: '',
      invalidFirstName: false,
      invalidLastName: false,
      invalidEmail: false,
      invalidMessage: false,
    };
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeFocus = this.handleChangeFocus.bind(this);
    this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
    this.sendMail = this.sendMail.bind(this);
  }

  onOpenModal() {
    this.setState({ open: true });
  }

  onCloseModal() {
    this.setState({ open: false });
  }
  handleChange(name, value) {
    this.setState({ ...this.state, [name]: value });
  }

  handleChangeFocus(name) {
    this.setState({ ...this.state, [name]: false });
  }
  handleTextAreaChange(name, value) {
    this.setState({ ...this.state, [name]: value.target.value });
  }
  sendMail() {
    const { firstName, lastName, email, message } = this.state;
    const updated = {};
    let validFirstName = false;
    let validLastName = false;
    let validEmail = false;
    let validMessage = false;

    const enteredName = regExForName.test(firstName);
    if (firstName !== '' && enteredName) {
      validFirstName = true;
    } else {
      updated.invalidFirstName = true;
    }

    const enteredLastName = regExForName.test(lastName);
    if (lastName === '') {
      validLastName = true;
    } else if (enteredLastName) {
      updated.invalidLastName = false;
      validLastName = true;
    } else {
      updated.invalidLastName = true;
    }

    const enteredEmail = regExForEmail.test(email);
    if (email !== '' && enteredEmail) {
      validEmail = true;
    } else {
      updated.invalidEmail = true;
    }

    if (message !== '') {
      validMessage = true;
    } else {
      updated.invalidMessage = true;
    }

    if (validFirstName && validLastName && validEmail && validMessage) {
      let payload = {};
      payload = Object.assign(payload, {
        firstname: this.state.firstName,
        lastname: this.state.lastName,
        email: this.state.email,
        message: this.state.message,
      });
      this.setState({ firstName: '', lastName: '', email: '', message: '' });
      this.props.sendContactForm(payload);
      this.onOpenModal();
    } else {
      this.setState(updated);
    }
  }
  render() {
    const { invalidFirstName, invalidLastName, invalidEmail, invalidMessage, open } = this.state;
    return (
      <div className={cn('row', styles.contactContainer)}>
        <Modal style={modalStyle} isOpen={open} onRequestClose={this.onCloseModal} >
          We will get back to you soon. Keep Exploring!
          <button className={styles.okbuttonModal} onClick={this.onCloseModal} >OK</button>
        </Modal>
        <span className={cn('col s12', styles.text)}>Fill out this form to contact us if you have any further questions</span>
        <div className={cn('col s12', styles.fullWidth)}>
          <div className={invalidFirstName === false ? cn('col s6', styles.firstName) : cn('col s6', styles.firstNameOnError)}>
            <Input
              value={this.state.firstName}
              type="text"
              placeholder="FIRST NAME"
              onChange={val => this.handleChange('firstName', val)}
              onFocus={() => this.handleChangeFocus('invalidFirstName')}
            />
          </div>
          <div className={invalidLastName === false ? cn('col s6', styles.lastName) : cn('col s6', styles.lastNameOnError)}>
            <Input
              value={this.state.lastName}
              type="text" placeholder="LAST NAME"
              onChange={val => this.handleChange('lastName', val)}
              onFocus={() => this.handleChangeFocus('invalidLastName')}
            />
          </div>
        </div>
        <div className={invalidEmail === false ? cn('col s12', styles.emailField) : cn('col s12', styles.emailFieldOnError)}>
          <Input
            value={this.state.email}
            type="Email" placeholder="ENTER EMAIL"
            onChange={val => this.handleChange('email', val)}
            onFocus={() => this.handleChangeFocus('invalidEmail')}
          />
        </div>
        <div className={cn('col s12', styles.fullWidth)}>
          <div className={cn('col s12', styles.textareaContainer)}>
            <textarea
              value={this.state.message}
              className={invalidMessage === false ? styles.textarea : styles.textareaOnError}
              placeholder="MESSAGE"
              onChange={val => this.handleTextAreaChange('message', val)}
              onFocus={() => this.handleChangeFocus('invalidMessage')}
            />
          </div>
        </div>
        <div className={cn('col s12', styles.fullWidth)}>
          <Button label="SUBMIT" className={styles.submitButton} onClick={this.sendMail} raised />
        </div>
      </div>
    );
  }
}


export default Sendgrid(FooterContact);



// WEBPACK FOOTER //
// ./src/components/FooterContact/FooterContact.js